/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CancelBatchRequest = {
  batchId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const CancelBatchRequest$inboundSchema: z.ZodType<
  CancelBatchRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  batch_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "batch_id": "batchId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type CancelBatchRequest$Outbound = {
  batch_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const CancelBatchRequest$outboundSchema: z.ZodType<
  CancelBatchRequest$Outbound,
  z.ZodTypeDef,
  CancelBatchRequest
> = z.object({
  batchId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    batchId: "batch_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function cancelBatchRequestToJSON(
  cancelBatchRequest: CancelBatchRequest,
): string {
  return JSON.stringify(
    CancelBatchRequest$outboundSchema.parse(cancelBatchRequest),
  );
}
export function cancelBatchRequestFromJSON(
  jsonString: string,
): SafeParseResult<CancelBatchRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CancelBatchRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CancelBatchRequest' from JSON`,
  );
}
